import store from "@/store";

const triggerAlert = async (binding) => {
  setTimeout(async () => {
    await store.dispatch("showConfirmDialog", {
      ...binding.value,
    });
  }, 0);
};

export default {
  bind(el, binding) {
    el.style.cursor = "pointer";
    
    el.addEventListener("click", async () => {
      await triggerAlert(binding);
    });
  },
};
